<script>
  import { _ } from "$helpers/i18n.js";
  import { Accordion, DataTable } from "$lib";
  import { globalStore } from "../../store/globalStore.js";

  const isMobile = globalStore.isMobile;

  let activeIndex = null;
  let opens = {};

  function toggle(i) {
    if ($isMobile) {
      activeIndex = activeIndex === i ? null : i;
    } else {
      opens = { ...opens, [i]: !opens[i] };
    }
  }

  // Inicializamos las variables profitTable1Headers y profitTable1Rows, como variables reactivas, para que se actualicen cada vez que cambie el país seleccionado.
  $: profitTable1Headers = [
    $_('profit.explanation.table_1.1_1'),
    $_('profit.explanation.table_1.1_2'),
    $_('profit.explanation.table_1.1_3'),
  ];

  $: profitTable1Rows = [
    [$_('profit.explanation.table_1.2_1'), $_('profit.explanation.table_1.2_2'), $_('profit.explanation.table_1.2_3')],
    [$_('profit.explanation.table_1.3_1'), $_('profit.explanation.table_1.3_2'), $_('profit.explanation.table_1.3_3')],
    [$_('profit.explanation.table_1.4_1'), $_('profit.explanation.table_1.4_2'), $_('profit.explanation.table_1.4_3')],
  ];

  $: profitTable2Headers = [
    $_('profit.explanation.table_1.1_1'),
    $_('profit.explanation.table_2.1_2'),
    $_('profit.explanation.table_1.1_3'),
  ];

  $: profitTable2Rows = [
    [$_('profit.explanation.table_1.2_1'), $_('profit.explanation.table_2.2_2'), $_('profit.explanation.table_2.2_3')],
    [$_('profit.explanation.table_1.3_1'), $_('profit.explanation.table_2.3_2'), $_('profit.explanation.table_2.3_3')],
    [$_('profit.explanation.table_1.4_1'), $_('profit.explanation.table_2.4_2'), $_('profit.explanation.table_2.4_3')],
  ];

  $: profitTable3Rows = [
    [$_('profit.explanation.table_3.2_1'), $_('profit.explanation.table_3.2_2'), $_('profit.explanation.table_3.2_3')],
    [$_('profit.explanation.table_3.3_1'), $_('profit.explanation.table_3.3_2'), $_('profit.explanation.table_3.3_3')],
    [$_('profit.explanation.table_3.4_1'), $_('profit.explanation.table_3.4_2'), $_('profit.explanation.table_3.4_3')],
  ];

  $: profitTable4Rows = [
    [$_('profit.explanation.table_3.2_1'), $_('profit.explanation.table_4.2_2'), $_('profit.explanation.table_4.2_3')],
    [$_('profit.explanation.table_4.3_1'), $_('profit.explanation.table_4.3_2'), $_('profit.explanation.table_4.3_3')],
    [$_('profit.explanation.table_4.4_1'), $_('profit.explanation.table_4.4_2'), $_('profit.explanation.table_4.4_3')],
  ];

  $: profitTable5Rows = [
    [$_('profit.explanation.table_5.2_1'), $_('profit.explanation.table_5.2_2'), $_('profit.explanation.table_5.2_3')],
    [$_('profit.explanation.table_5.3_1'), $_('profit.explanation.table_5.3_2'), $_('profit.explanation.table_5.3_3')],
    [$_('profit.explanation.table_5.4_1'), $_('profit.explanation.table_5.4_2'), $_('profit.explanation.table_5.4_3')],
  ];

  $: profitTable6Rows = [
    [$_('profit.explanation.table_6.2_1'), $_('profit.explanation.table_6.2_2'), $_('profit.explanation.table_6.2_3')],
    [$_('profit.explanation.table_6.3_1'), $_('profit.explanation.table_6.3_2'), $_('profit.explanation.table_6.3_3')],
    [$_('profit.explanation.table_6.4_1'), $_('profit.explanation.table_6.4_2'), $_('profit.explanation.table_6.4_3')],
  ];

  $: profitTable7Rows = [
    [$_('profit.explanation.table_7.2_1'), $_('profit.explanation.table_7.2_2'), $_('profit.explanation.table_7.2_3')],
    [$_('profit.explanation.table_7.3_1'), $_('profit.explanation.table_7.3_2'), $_('profit.explanation.table_7.3_3')],
    [$_('profit.explanation.table_7.4_1'), $_('profit.explanation.table_7.4_2'), $_('profit.explanation.table_7.4_3')],
  ];

  $: profitTable8Rows = [
    [$_('profit.explanation.table_8.2_1'), $_('profit.explanation.table_8.2_2'), $_('profit.explanation.table_8.2_3')],
    [$_('profit.explanation.table_8.3_1'), $_('profit.explanation.table_8.3_2'), $_('profit.explanation.table_8.3_3')],
    [$_('profit.explanation.table_8.4_1'), $_('profit.explanation.table_8.4_2'), $_('profit.explanation.table_8.4_3')],
  ];
</script>

<div class="explanation-container">
  <Accordion title={$_("explanation.title_1")} open={$isMobile ? activeIndex === 0 : !!opens[0]} onToggle={() => toggle(0)}>
    <div class="explanation-item">
      <p>{$_("profit.explanation.paragraph_1")}</p>
      <ol>
        <li>{$_("profit.explanation.item_1")}</li>
        <li>{$_("profit.explanation.item_2")}</li>
      </ol>
      <p>
        {$_("profit.explanation.item_explanation_1")}
        {$_("profit.explanation.item_first")}
        {$_("profit.explanation.item_explanation_2")}
        <strong>{$_("profit.explanation.item_explanation_bold_1")}</strong>
        {$_("profit.explanation.item_explanation_3")}
        <strong>{$_("common.calculate_bold")}</strong>{$_("profit.explanation.item_explanation_4")}
      </p>

      <!-- Formula margen sobre costos -->
      <div class="formula">
        <span class="left">{$_("profit.explanation.form_left_part")}</span>
        <span class="frac">
          <span class="top">{$_("profit.explanation.form_top_part")}</span>
          <span class="bottom">{$_("profit.explanation.form_down_part")}</span>
        </span>
        <span class="right">{$_("profit.explanation.form_right_part")}</span>
      </div>

      <p>
        {$_("profit.explanation.item_explanation_1")}
        {$_("profit.explanation.item_second")}
        {$_("profit.explanation.item_explanation_2")}
        <strong>{$_("profit.explanation.item_explanation_bold_2")}</strong>
        {$_("profit.explanation.item_explanation_3")}
        <strong>{$_("common.calculate_bold")}</strong>{$_("profit.explanation.item_explanation_4")}
      </p>

      <!-- Formula margen sobre ventas -->
      <div class="formula">
        <span class="left">{$_("profit.explanation.form_left_part_2")}</span>
        <span class="frac">
          <span class="top">{$_("profit.explanation.form_top_part")}</span>
          <span class="bottom">{$_("profit.explanation.form_down_part_2")}</span>
        </span>
        <span class="right">{$_("profit.explanation.form_right_part")}</span>
      </div>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_2")} open={$isMobile ? activeIndex === 1 : !!opens[1]} onToggle={() => toggle(1)}>
    <div class="explanation-item">
      <ul class="punteo-list">
        <li>
          {$_("explanation.important_concepts_common_2")}
          {$_("profit.explanation.item_1_concepts_1")}
          <strong>{$_("profit.explanation.item_1_concepts_bold")}</strong>{$_("profit.explanation.item_1_concepts_2")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_1")}
          <strong>{$_("profit.explanation.item_2_concepts_bold")}</strong>{$_("profit.explanation.item_2_concepts")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_1")}
          {$_("profit.explanation.item_3_concepts_1")}
          <strong>{$_("profit.explanation.item_3_concepts_bold")}</strong>{$_("profit.explanation.item_3_concepts_2")}
        </li>
        <li>
          {$_("explanation.important_concepts_common_2")}
          {$_("profit.explanation.item_4_concepts_1")}
          <strong>{$_("profit.explanation.item_4_concepts_bold")}</strong>
          {$_("profit.explanation.item_4_concepts_2")}
        </li>
      </ul>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_3")} open={$isMobile ? activeIndex === 2 : !!opens[2]} onToggle={() => toggle(2)}>
    <div class="explanation-item">
      <p>{$_("profit.explanation.paragraph_2")}</p>
      <ul class="punteo-list">
        <li>{$_("profit.explanation.item_1_factors")}</li>
        <li>{$_("profit.explanation.item_2_factors")}</li>
        <li>{$_("profit.explanation.item_3_factors")}</li>
        <li>{$_("profit.explanation.item_4_factors")}</li>
        <li>{$_("profit.explanation.item_5_factors")}</li>
        <li>{$_("profit.explanation.item_6_factors")}</li>
        <li>{$_("profit.explanation.item_7_factors")}</li>
        <li>{$_("profit.explanation.item_8_factors")}</li>
      </ul>
      <p>{$_("profit.explanation.paragraph_3")}</p>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_4")} open={$isMobile ? activeIndex === 3 : !!opens[3]} onToggle={() => toggle(3)}>
    <div class="explanation-item">
      <p>
        {$_("profit.explanation.paragraph_4_1")}
        <strong>{$_("profit.explanation.paragraph_4_bold")}</strong>
        {$_("profit.explanation.paragraph_4_2")}
      </p>
      <DataTable headers={profitTable1Headers} rows={profitTable1Rows} boldColumn={1} centerAlignColumns={[1]}/>
      
      <p>
        {$_("profit.explanation.paragraph_5_1")}
        <strong>{$_("profit.explanation.paragraph_5_bold")}</strong>
        {$_("profit.explanation.paragraph_5_2")}
      </p>
      <DataTable headers={profitTable2Headers} rows={profitTable2Rows} boldColumn={1} centerAlignColumns={[1]}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_5")} open={$isMobile ? activeIndex === 4 : !!opens[4]} onToggle={() => toggle(4)}>
    <div class="explanation-item">
      <p>
        {$_("profit.explanation.paragraph_4_1")}
        <strong>{$_("profit.explanation.paragraph_4_bold")}</strong>
        {$_("profit.explanation.paragraph_4_2")}
      </p>
      <DataTable headers={profitTable1Headers} rows={profitTable3Rows} boldColumn={1} centerAlignColumns={[1]}/>
      
      <p>
        {$_("profit.explanation.paragraph_5_1")}
        <strong>{$_("profit.explanation.paragraph_5_bold")}</strong>
        {$_("profit.explanation.paragraph_5_2")}
      </p>
      <DataTable headers={profitTable2Headers} rows={profitTable4Rows} boldColumn={1} centerAlignColumns={[1]}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_6")} open={$isMobile ? activeIndex === 5 : !!opens[5]} onToggle={() => toggle(5)}>
    <div class="explanation-item">
      <p>
        {$_("profit.explanation.paragraph_4_1")}
        <strong>{$_("profit.explanation.paragraph_4_bold")}</strong>
        {$_("profit.explanation.paragraph_4_2")}
      </p>
      <DataTable headers={profitTable1Headers} rows={profitTable5Rows} boldColumn={1} centerAlignColumns={[1]}/>
      
      <p>
        {$_("profit.explanation.paragraph_5_1")}
        <strong>{$_("profit.explanation.paragraph_5_bold")}</strong>
        {$_("profit.explanation.paragraph_5_2")}
      </p>
      <DataTable headers={profitTable2Headers} rows={profitTable6Rows} boldColumn={1} centerAlignColumns={[1]}/>
    </div>
  </Accordion>
  <Accordion title={$_("explanation.title_7")} open={$isMobile ? activeIndex === 6 : !!opens[6]} onToggle={() => toggle(6)}>
    <div class="explanation-item">
      <p>
        {$_("profit.explanation.paragraph_4_1")}
        <strong>{$_("profit.explanation.paragraph_4_bold")}</strong>
        {$_("profit.explanation.paragraph_4_2")}
      </p>
      <DataTable headers={profitTable1Headers} rows={profitTable7Rows} boldColumn={1} centerAlignColumns={[1]} columnWidths={["163px", "233px", "453px"]}/>
      
      <p>
        {$_("profit.explanation.paragraph_5_1")}
        <strong>{$_("profit.explanation.paragraph_5_bold")}</strong>
        {$_("profit.explanation.paragraph_5_2")}
      </p>
      <DataTable headers={profitTable2Headers} rows={profitTable8Rows} boldColumn={1} centerAlignColumns={[1]} columnWidths={["162px", "233px", "453px"]}/>
    </div>
  </Accordion>
</div>